import { ReactElement } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';

import { ThemeProvider, CssBaseline } from '@mui/material';

import Toaster from '../../components/Toaster';
import { store } from '../../store';
import theme from '../../theme';
import Footer from '../Footer';
import Games from '../Games';
import Header from '../Header';
import Products from '../Products';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false
    }
  }
});

export default function Container(): ReactElement {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />

          <Header />
          <Products />
          <Games />
          <Footer />

          <Toaster />
        </ThemeProvider>
      </QueryClientProvider>
    </Provider>
  );
}
